import React from 'react';
import Grid from '@material-ui/core/Grid';

const ManageCallSkeleton = () => {
    return (<Grid container spacing={0}>
        <Grid item xs={12}>
            <div className='manage-call-skeleton'>
                <i className='call-skeleton-main-title'/>
                <i className='call-skeleton-regarding'/>
                <i className='call-skeleton-desc'/>
                <i className='call-skeleton-id'/>

                <div className={'call-details-frame-skeleton'}>
                <i className='call-skeleton-title'/>
                <div className={'prop-wrap-skeleton'}>
                    <i className='call-skeleton-key'/>
                    <div className={'prop-content-skeleton'} >
                        <i className='call-skeleton-value'/>
                        <i className='call-skeleton-edit-icon'/>
                    </div>
                </div>
                <div className={'prop-wrap-skeleton'}>
                    <i className='call-skeleton-key'/>
                    <div className={'prop-content-skeleton'} >
                        <i className='call-skeleton-value'/>
                        <i className='call-skeleton-edit-icon'/>
                    </div>
                </div>
                <i className='call-skeleton-submit'/>
            </div>
            </div>
        </Grid>
    </Grid>);
};

export default ManageCallSkeleton;
